export default __webpack_public_path__ + "static/media/soc-catalog-desktop-forward.2881ba5f.png";